module.exports = __webpack_public_path__ + "img/23EC.b205e44e.svg";